import { pxToRem } from '../../../../utils';
export var flexItemVariables = function flexItemVariables() {
  return {
    'size.half': '50%',
    'size.quarter': '25%',
    'size.small': pxToRem(150),
    'size.medium': pxToRem(200),
    'size.large': pxToRem(300)
  };
};
//# sourceMappingURL=flexItemVariables.js.map
